import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FC } from 'react';
import SupplierAssetDetailPageDisplay from '../supplier_asset_detail_page_display/SupplierAssetDetailPageDisplay';
import { isInternalTech } from '../../utils/AuthUtils';
import AssetDetailPageDisplay from '../asset_detail_page_display/AssetDetailPageDisplay';
import { getEntityById, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import OWResult from '../OWResult';

const SupplierAssetsDetailsDetailPage: FC<any> = ({
	asset,
	assetsFetching,
	assetsError,
	currentUser,
}): React.ReactElement => {
	const assetAccessError = nullSafeGetOrElse('length', assetsError, 0) > 0;
	const fetching = !asset.id && assetsFetching;
	const isExternalSupplier = !isInternalTech(currentUser);
	return fetching ? (
		<PageLoadingPlaceholder />
	) : assetAccessError ? (
		<OWResult
			error={'Do not have permission to perform this action'}
			title="You do not have access to this asset"
		/>
	) : isExternalSupplier ? (
		<SupplierAssetDetailPageDisplay asset={asset} />
	) : (
		<AssetDetailPageDisplay key={asset.id} asset={asset} />
	);
};

const mapStateToProps = (state, ownProps) => ({
	assetsError: state.assets.fetchErrors,
	assetsFetching: state.assets.fetching,
	asset: getEntityById(ownProps.match.params.id, state.assets),
	currentUser: state.session.currentUser,
});

export default withRouter<any, any>(connect(mapStateToProps)(SupplierAssetsDetailsDetailPage));
